/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useMemo, type ReactNode } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { PACKAGE_NAME, TOP_LEVEL_ERROR_BOUNDARY_ID } from '../../constants.tsx';

type Props = {
	id: string;
	children: ReactNode;
};

export const TopLevelErrorBoundary = ({ id, children }: Props): React.JSX.Element => {
	const EVENT_DATA = useMemo(() => ({ id }), [id]);

	return (
		<JSErrorBoundary
			id={`${TOP_LEVEL_ERROR_BOUNDARY_ID}.${id}`}
			packageName={PACKAGE_NAME}
			extraEventData={EVENT_DATA}
			fallback="unmount"
		>
			{children}
		</JSErrorBoundary>
	);
};
